<template>
    <div>
	<div class="wrap" v-if="isMobile">
		 <div v-if="isShow">
            <div class="msignUp">
                <h2>游戏代练师技能认定实操考试预约</h2>

			<div class="exam-search-result" v-if="hasData">
				<div class="item">
						<div class="label-item">考试名称：</div>
						<div class="input-item sut">
							{{title}}
						</div>
				</div>

				<div class="item">
						<div class="label-item">考生姓名：</div>
						<div class="input-item sut">
							{{name}}
						</div>
				</div>

				<div class="item">
						<div class="label-item">证件号码：</div>
						<div class="input-item sut">
							{{idcardNo}}
						</div>
				</div>

				<div class="item">
					<div class="label-item">考试时间：</div>
					<div class="input-item sut">
						{{formatDate(startDate)}}~{{formatDate(endDate)}}
					</div>
				</div>

				<div class="item">
					<div class="label-item">剩余次数：</div>
					<div class="input-item sut">
						{{operationCount}}次
					</div>
				</div>
				
				<template v-if="status1==10">
					<!--   等待审核   -->
					<div class="item" >
						<el-button type="info" size="small" plain>审核中</el-button>
						<div>{{comment}}</div>
					</div>
				</template>
				<template v-else-if="status1==11">
					<!--   审核通过   -->
					<div class="item" >
					<div>{{comment}}</div>
					</div>
				</template>
				<template v-else-if="status1==12">
					<!--   考试成功   -->
					<div class="item">
					<div class="label-item">考试成绩：</div>
					<div class="input-item sut">
						考试通过
					</div>
					</div>

					<div class="item" >
						<router-link  to="/home" ><el-button size="small">返 回</el-button></router-link>
					</div>
				</template>
				<template v-else-if="status1==13">
					<!--   考试失败   -->
					<div class="item">
						<div class="label-item">考试成绩：</div>
						<div class="input-item sut">
							考试不通过
						</div>
					</div>

					<div class="item" >
						<el-button type="primary" size="small" @click="orderagain">重新预约</el-button>
					</div>
				</template>

				<div class="item" @click="showExample">
						<span class="tips">实操考试考前须知</span>
				</div>
            </div>
			<div class="exam-search-result" v-else>
					<div class="item">
                	<div class="label-item">预约时间：</div>
					<div class="input-item">
						<el-select size="small" v-model="date" class="el-select-ts" placeholder="选择预约时间">
							<el-option v-for="item in dateArr" :key="item" :label="item" :value="item"></el-option>
						</el-select>
					</div>
					</div>

					<div class="item">
						<div class="label-item">考试名称：</div>
						<div class="input-item sut">
							{{level}}游戏代练师-{{game}}技能认定实操考试
						</div>
					</div>

					<div class="item">
						<div class="label-item">考生姓名：</div>
						<div class="input-item sut">
							{{name}}
						</div>
					</div>

					<div class="item">
						<div class="label-item">证件号码：</div>
						<div class="input-item sut">
							{{idcardNo}}
						</div>
					</div>

					<div class="item">
						<div class="label-item">剩余次数：</div>
						<div class="input-item sut">
							{{operationCount}}次
						</div>
					</div>

					<div class="item" >
						<el-button type="primary" @click="order()" size="small">预 约</el-button>
					</div>

					<div class="item" @click="showExample">
						<span class="tips">实操考试考前须知</span>
					</div>
			</div>

            </div>
        </div>
	</div>
	<div v-else>
	<div class="content" v-if="isShow">
            <div class="signUp">
                <h2>游戏代练师技能认定实操考试预约</h2>

			<div class="exam-search-result" v-if="hasData">
				<div class="item">
						<div class="label-item">考试名称：</div>
						<div class="input-item sut">
							{{title}}
						</div>
				</div>

				<div class="item">
						<div class="label-item">考生姓名：</div>
						<div class="input-item sut">
							{{name}}
						</div>
				</div>

				<div class="item">
						<div class="label-item">证件号码：</div>
						<div class="input-item sut">
							{{idcardNo}}
						</div>
				</div>

				<div class="item">
					<div class="label-item">考试时间：</div>
					<div class="input-item sut">
						{{formatDate(startDate)}}~{{formatDate(endDate)}}
					</div>
				</div>

				<div class="item">
					<div class="label-item">剩余次数：</div>
					<div class="input-item sut">
						{{operationCount}}次
					</div>
				</div>
				
				<template v-if="status1==10">
					<!--   等待审核   -->
					<div class="item" >
						<el-button type="info" size="small" plain>审核中</el-button>
						<div>{{comment}}</div>
					</div>
				</template>
				<template v-else-if="status1==11">
					<!--   审核通过   -->
					<div class="item" >
					<div>{{comment}}</div>
					</div>
				</template>
				<template v-else-if="status1==12">
					<!--   考试成功   -->
					<div class="item">
					<div class="label-item">考试成绩：</div>
					<div class="input-item sut">
						考试通过
					</div>
					</div>

					<div class="item" >
						<router-link  to="/home" ><el-button size="small">返 回</el-button></router-link>
					</div>
				</template>
				<template v-else-if="status1==13">
					<!--   考试失败   -->
					<div class="item">
						<div class="label-item">考试成绩：</div>
						<div class="input-item sut">
							考试不通过
						</div>
					</div>

					<div class="item" >
						<el-button type="primary" size="small" @click="orderagain">重新预约</el-button>
					</div>
				</template>

				<div class="item" @click="showExample">
						<span class="tips">实操考试考前须知</span>
				</div>
            </div>
			<div class="exam-search-result" v-else>
					<div class="item">
						<div class="label-item">预约考试时间：</div>
						<div class="input-item">
							<el-select size="small" v-model="date"  class="el-select-ts"  placeholder="选择预约时间">
								<el-option v-for="item in dateArr" :key="item" :label="item" :value="item"></el-option>
							</el-select>
						</div>
					</div>

					<div class="item">
						<div class="label-item">考试名称：</div>
						<div class="input-item sut">
							{{level}}游戏代练师-{{game}}技能认定实操考试
						</div>
					</div>

					<div class="item">
						<div class="label-item">考生姓名：</div>
						<div class="input-item sut">
							{{name}}
						</div>
					</div>

					<div class="item">
						<div class="label-item">证件号码：</div>
						<div class="input-item sut">
							{{idcardNo}}
						</div>
					</div>

					<div class="item">
						<div class="label-item">剩余次数：</div>
						<div class="input-item sut">
							{{operationCount}}次
						</div>
					</div>

					<div class="item" >
						<el-button type="primary" @click="order()" size="small">预 约</el-button>
					</div>
					<div class="item" @click="showExample">
						<span class="tips">实操考试考前须知</span>
					</div>
			</div>

            </div>
        </div>
		</div>
    </div>
</template>
<style scoped>
.signUp{background:#fff; overflow:hidden; margin:16px 0; font-size:14px; padding-bottom: 50px; }
.signUp h2{ height:84px; line-height:84px; font-size:24px; border-bottom:solid 1px #e8e8e8; color:#272727; font-weight:normal; margin-bottom: 50px; text-align: center;}
.signUp .item{text-align: center; padding-bottom:24px; color:#8c8c8c; line-height: 28px;}
.signUp .label-item{ width:40%;display: inline-block; text-align: right; }
.signUp .input-item{width:58%; display: inline-block; text-align: left; font-size:16px;color:#111; }
.signUp input{height:20px;}
.signUp .msg{font-size:14px; color:#f5222d; line-height:24px; position: absolute;}
.signUp .msg1{font-size:14px; color:#f5222d; line-height:24px; position: absolute; padding-left:135px;}

.signUp .exam-search-result{background:#fff; overflow:hidden; margin:16px 0; font-size:14px; padding-bottom:40px; }
.signUp .exam-search-result .item{text-align: center; padding-bottom:24px; color:#8c8c8c; line-height: 28px;}
.signUp .exam-search-result .label-item{ width:40%;display: inline-block; text-align: right; }
.signUp .exam-search-result .input-item{width:58%; display: inline-block; text-align: left; font-size:16px;color:#111; }
.signUp .exam-search-result input{height:20px;}
.signUp .exam-search-result .msg{font-size:14px; color:#f5222d; line-height:24px; position: absolute;}
.signUp .exam-search-result .msg1{font-size:14px; color:#f5222d; line-height:24px; position: absolute; padding-left:135px;}
.signUp .exam-search-result span{display: block; font-size: 16px; margin-top: 24px;}
.signUp .tips{font-size:16px; color:#1890ff; cursor: pointer;}

.msignUp{background:#fff; overflow:hidden; margin:0.8rem 0; font-size:1.2rem; padding-bottom:2.5rem; }
.msignUp h2{height:5rem; line-height:5rem; font-size:1.4rem;  border-bottom:solid 1px #e8e8e8; color:#272727; font-weight:normal;  text-align: center; } 
.msignUp .item{text-align: center; padding-bottom:1.2rem; color:#8c8c8c; line-height: 1.4rem;}
.msignUp .label-item{ width:25%;display: inline-block; text-align: right; }
.msignUp .input-item{width:73%; display: inline-block; text-align: left; font-size:0.8rem;color:#111; }
.msignUp input{height:1rem;}
.msignUp .msg{font-size:0.7rem; color:#f5222d; line-height:1.2rem; position: absolute;}
.msignUp .msg1{font-size:0.7rem; color:#f5222d; line-height:1.2rem; position: absolute;}

.msignUp .exam-search-result{background:#fff; overflow:hidden; margin:0.8rem 0; font-size:1.2rem; padding-bottom:2rem; }
.msignUp .exam-search-result .item{text-align: center;  padding:0.8rem 0; color:#8c8c8c; }
.msignUp .exam-search-result .label-item{ width:20%;display: inline-block; text-align: right; }
.msignUp .exam-search-result .input-item{ display: inline-block; text-align: left; font-size:1.2rem;color:#111; }
.msignUp .exam-search-result input{height:1rem;}
.msignUp .exam-search-result .msg{font-size:1.2rem; color:#f5222d; line-height:1.2rem; position: absolute;}
.msignUp .exam-search-result .msg1{font-size:1.2rem; color:#f5222d;line-height:1.2rem;position: absolute; }
.msignUp .exam-search-result span{display: block;font-size: 0.8rem; margin-top:1.2rem;}
.msignUp .exam-search-result .tips{font-size:1.2rem; color:#1890ff; }
</style>
<script>  
	export default {
		name: 'signUp',
		methods: {
			order(){
				var self=this;
				if(this.status==12){
					if(this.baomingId>0){
						if(this.operationCount>0){
							if(this.date!=''){
							const self = this;
							var data= self.common.GetlocalStorage("UnLockUserData");
							var userId=JSON.parse(data).UserID;
							self.http.ajaxGet("AddOperation?UserID="+userId+"&BaomingID="+self.baomingId+"&Date="+self.date,function(res){
							if(res.ReturnCode == 1){
								self.getResult();
							}else{
								self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
							}	
							},function(err){
								self.$alert(err, '错误', {confirmButtonText: '确定'});
							})
							}else{
								this.$message({message: "请选择预约考试时间", type: 'warning'}); 
							}
						}else{
							if(self.status1==13){
								if(self.isMobile){
									self.$alert('您的实操考试次数已用完，请重新报名', '', {
									confirmButtonText: '确定',
									customClass:'mfuli-message-box',
									type:"info",
									showClose:false,
									callback: action => {
										self.$router.push({path:'/sign-up'});
									}
									});
								}else{
									self.$alert('您的实操考试次数已用完，请重新报名', '', {
									confirmButtonText: '确定',
									type:"info",
									showClose:false,
									callback: action => {
										self.$router.push({path:'/sign-up'});
									}
									});
								}
							}
						}
					}
				}else{
					this.$message({message: "当前不是实操考试流程，不能预约", type: 'warning'}); 
				}
			},
			getResult(){
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
				var userId=JSON.parse(data).UserID;
				self.isShow=false;
				self.http.ajaxGet("Operation?UserID="+userId,function(res){
					if(res.ReturnCode == 1){
						self.hasData=res.Result[0].HasData==1?true:false;
						self.name=res.Result[0].Name;
						self.idcardNo=res.Result[0].IDCard;
						self.comment=res.Result[0].Comment;
						self.title=res.Result[0].Title;
						self.startDate=res.Result[0].StartDate;
						self.endDate=res.Result[0].EndDate;
						self.status=res.Result[0].Status1;
						self.status1=res.Result[0].Status;
						self.type=res.Result[0].Type;
						self.game=res.Result[0].Game;
						self.baomingId=res.Result[0].BaoMingID;
						self.operationCount=res.Result[0].OperationCount;
						self.level=res.Result[0].Level;
						self.isShow=true;

						if(self.baomingId>0){
							if(self.operationCount==0 && self.status1==13){
								if(self.isMobile){
									self.$alert('您的实操考试次数已用完，请重新报名', '', {
									confirmButtonText: '确定',
									customClass:'mfuli-message-box',
									type:"info",
									showClose:false,
									callback: action => {
										self.$router.push({path:'/sign-up'});
									}
									});
								}else{
									self.$alert('您的实操考试次数已用完，请重新报名', '', {
									confirmButtonText: '确定',
									type:"info",
									showClose:false,
									callback: action => {
										self.$router.push({path:'/sign-up'});
									}
									});
								}
							}
						}
					}
					else if(res.ReturnCode==-1){
						if(isMobile){
							self.$alert(res.Message, '', {
							confirmButtonText: '去实名',
							customClass:'mfuli-message-box',
							type:"info",
							showClose:false,
							callback: action => {
								self.$router.push({path:'/auth'});
							}
							});
						}else{
							self.$alert(res.Message, '', {
							confirmButtonText: '去实名',
							type:"info",
							showClose:false,
							callback: action => {
								self.$router.push({path:'/auth'});
							}
							});
						}
					}
					else if(res.ReturnCode==-2){
						if(self.isMobile){
							self.$alert(res.Message, '', {
							confirmButtonText: '去报名',
							customClass:'mfuli-message-box',
							type:"info",
							showClose:false,
							callback: action => {
								self.$router.push({path:'/sign-up'});
							}
							});
						}else{
							self.$alert(res.Message, '', {
							confirmButtonText: '去报名',
							type:"info",
							showClose:false,
							callback: action => {
								self.$router.push({path:'/sign-up'});
							}
							});
						}
					}
					else if(res.ReturnCode==-3){
						if(self.isMobile){
							self.$alert(res.Message, '', {
							confirmButtonText: '确定',
							customClass:'mfuli-message-box',
							type:"info",
							showClose:false,
							callback: action => {
								self.$router.push({path:'/home'});
							}
							});
						}else{
							self.$alert(res.Message, '', {
							confirmButtonText: '确定',
							type:"info",
							showClose:false,
							callback: action => {
								self.$router.push({path:'/home'});
							}
							});
						}
					}
					else{
						self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
					}	
				},function(err){
					self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
			},
			changeType(val){
				if(val==1)
					return "身份证号";
				else if(val==2)
					return "港澳通行证";
				else if(val==3)
					return "台湾通行证";
				else if(val==4)
					return "外国护照";		
			},
			formatDate(date){
				if(date){
					return this.http.dateFormat1("yyyy-MM-dd hh:mm:ss",date);
				}else{
					return "";
				}
			},
			orderagain(){
				var self=this;
				if(this.status==12){
					if(this.baomingId>0){
						if(this.operationCount>0){
							this.hasData=false;
						}else{
							if(self.isMobile){
								self.$alert('您的实操考试次数不足，请交补考费', '', {
								confirmButtonText: '确定',
								customClass:'mfuli-message-box',
								type:"info",
								showClose:false,
								callback: action => {
									self.$router.push({path:'/my-sign-up'});
								}
								});
							}else{
								self.$alert('您的实操考试次数不足，请交补考费', '', {
								confirmButtonText: '确定',
								type:"info",
								showClose:false,
								callback: action => {
									self.$router.push({path:'/my-sign-up'});
								}
								});
							}
						}
					}
				}else{
					this.$message({message: "当前不是实操考试流程，不能预约", type: 'warning'}); 
				}
			},
			showExample()
			{
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
				var userId=JSON.parse(data).UserID;
				self.http.ajaxGet("SysParam?UserID="+userId+"&ID=3",function(res){
				if(res.ReturnCode == 1){
					var contont=res.Result;
					if(self.isMobile){
						self.$alert(contont, '实操考试考前须知', {
							confirmButtonText: '确定',
							customClass:'mfuli-message-box',
							type:"info",
							showClose:false,
							dangerouslyUseHTMLString:true
						});
					}else{
						self.$alert(contont, '实操考试考前须知', {
							confirmButtonText: '确定',
							customClass:'fuli-message-box',
							type:"info",
							showClose:false,
							dangerouslyUseHTMLString:true
						});
					}
				}else{
					self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
				}	
				},function(err){
					self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
			},
			GetOperationOrder()
			{
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
				var userId=JSON.parse(data).UserID;
				self.http.ajaxGet("OperationOrder?UserID="+userId,function(res){
				if(res.ReturnCode == 1){
					self.dateArr=res.Result;
				}else{
					self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
				}	
				},function(err){
					self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
			}
		},
		data() {
			return {
				level:'',
				game:'',
				id:0,
				idcard:"",
				hasData:true,
				idcardNo:'',
				name:'',
				type:0,
				date:'',
				grade:'',
				comment:'',
				diffMinute:10,
				startDate:'',
				endDate:'',
				status:1,          //表示报名时的状态
				status1:1,         //表示预约的状态
				dateArr:[],
				baomingId:0,
				operationCount:0,
				isShow:false
			}
		},
		computed:{
			loading(){
				return this.$store.getters.loadingPara;
			},
			isMobile(){
				return this.common.isMobile();
			}
		},
		mounted: function () {
			// var dateTime=new Date();
			// dateTime=dateTime.setDate(dateTime.getDate()+3);
			// dateTime=new Date(dateTime);
			// for(var i=0;i<5;i++){
			// 	this.dateArr.push(this.http.dateFormat("yyyy-MM-dd",dateTime));
			// 	dateTime=dateTime.setDate(dateTime.getDate()+1);   //增加1天
			// 	dateTime=new Date(dateTime);
			// }

			this.GetOperationOrder();

			this.getResult();
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/operation.vue